import React from "react";
import ContactForm from "../CommentForm";
import "./style.css";

const ContactSection = () => {
  return (
    <div className="contact-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="contact-text">
              <h2>Contact Us</h2>
              <p>
                If you have any questions, please do not hesitate to send us a message. We reply within 24 hours !
              </p>
              <div className="contact-sub">
                <div className="contact-icon">
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                </div>
                <div className="contact-c">
                  <h4>Our Location</h4>
                  <span>1200 St. Laurent Blvd, Unit 517, Ottawa, ON K1K 3B8</span>
                </div>
              </div>
              <div className="contact-sub">
                <div className="contact-icon">
                  <i className="fa fa-phone" aria-hidden="true"></i>
                </div>
                <div className="contact-c">
                  <h4>Phone</h4>
                  <span>(613) 680-6804</span>
                </div>
              </div>
              <div className="contact-sub">
                <div className="contact-icon">
                  <i className="fa fa-fax" aria-hidden="true"></i>
                </div>
                <div className="contact-c">
                  <h4>Fax</h4>
                  <span>(613) 680-6804</span>
                </div>
              </div>
              <div className="contact-sub">
                <div className="contact-icon">
                  <i className="fa fa-envelope-o" aria-hidden="true"></i>
                </div>
                <div className="contact-c">
                  <h4>Email</h4>
                  <span>info@bturnerlaw.ca</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-lg-7 col-md-12 col-sm-12">
            <div className="contact-content">
              <div className="contact-form">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
